import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { device } from '../../../utils/constants';
import {
  LabBottomRule,
  labAos,
  labBodyMobile,
  labSectionPadMobile,
  labSubtitleMobile,
  labTitleMobile,
} from './labShared';

const Section = styled.section`
  color: #ffffff;
  font-family: 'MontserratMedium', Helvetica, Arial, sans-serif;
  box-sizing: border-box;
  padding-top: 5vw;
  ${labSectionPadMobile}
`;

const Inner = styled.div`
  max-width: min(52rem, 100%);
  margin: 0 auto;
`;

const ServicesHeading = styled.h2`
  margin: 0;
  text-align: center;
  font-family: 'MontserratBold', Helvetica, Arial, sans-serif;
  font-size: 3vw;
  text-transform: uppercase;
  margin-bottom: 6vw;
  ${labTitleMobile}

  @media ${device.mobile} {
    margin-bottom: clamp(2rem, 8vw, 3rem);
  }
`;

const ServiceBlock = styled.div`
  text-align: center;
  margin-bottom: 4vw;

  &:last-of-type {
    margin-bottom: 0;
  }

  @media ${device.mobile} {
    margin-bottom: clamp(1.75rem, 6vw, 2.5rem);
    text-align: left;
  }
`;

const CategoryTitle = styled.h3`
  margin: 0 0 1.2vw;
  font-family: 'MontserratBold', Helvetica, Arial, sans-serif;
  font-size: 1.4vw;
  text-transform: uppercase;
  ${labSubtitleMobile}

  @media ${device.mobile} {
    margin-bottom: clamp(0.5rem, 2vw, 0.75rem);
  }
`;

const CategoryBody = styled.p`
  margin: 0;
  font-size: 1.35vw;
  font-family: 'MontserratMedium';
  line-height: 1.45;
  ${labBodyMobile}
`;

const BottomBlock = styled.div`
  padding-top: 6vw;

  @media ${device.mobile} {
    padding-top: clamp(2.5rem, 8vw, 4rem);
  }
`;

const ServiceLab = () => {
  const { t } = useTranslation();

  const SERVICE_GROUPS = [
    {
      title: t('lab.service.items.01.title'),
      items: [
        t('lab.service.items.01.option1'),
        t('lab.service.items.01.option2'),
        t('lab.service.items.01.option3'),
      ],
    },
    {
      title: t('lab.service.items.02.title'),
      items: [
        t('lab.service.items.02.option1'),
        t('lab.service.items.02.option2'),
        t('lab.service.items.02.option3'),
        t('lab.service.items.02.option4'),
        t('lab.service.items.02.option5'),
      ],
    },
    {
      title: t('lab.service.items.03.title'),
      items: [
        t('lab.service.items.03.option1'),
        t('lab.service.items.03.option2'),
        t('lab.service.items.03.option3'),
        t('lab.service.items.03.option4'),
      ],
    },
    {
      title: t('lab.service.items.04.title'),
      items: [
        t('lab.service.items.04.option1'),
        t('lab.service.items.04.option2'),
        t('lab.service.items.04.option3'),
        t('lab.service.items.04.option4'),
        t('lab.service.items.04.option5'),
      ],
    },
  ];

  return (
    <Section aria-labelledby="lab-services-heading">
      <Inner>
        <ServicesHeading id="lab-services-heading" {...labAos('fade-up')}>
          Services
        </ServicesHeading>

        {SERVICE_GROUPS.map((group, index) => (
          <ServiceBlock key={group.title} {...labAos('fade-up', 100 + index * 100)}>
            <CategoryTitle>{group.title}</CategoryTitle>
            <CategoryBody>{group.items.join(' · ')}</CategoryBody>
          </ServiceBlock>
        ))}
      </Inner>

      <BottomBlock>
        <LabBottomRule aria-hidden />
      </BottomBlock>
    </Section>
  );
};

export default ServiceLab;
